export default function bookingGalleryDropdown(gallery) {
  const dropdown = gallery.querySelector(".booking-gallery__dropdown");
  if (!dropdown) return;
  dropdown.selectedIndex = 0;
  dropdown.addEventListener("change", () => {
    const target = document.querySelector(`#${dropdown.value}`);
    if (!target) return;
    const alreadyOpen = gallery.querySelector(".booking-gallery__topic--show");
    if (alreadyOpen) {
      alreadyOpen.classList.remove("booking-gallery__topic--show");
    }
    target.classList.add("booking-gallery__topic--show");
  });
}
